// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1RKtX","modalFooterButton":"ModalNotes_modalFooterButton__3sQzx"};